import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Landing from "@/pages/Landing";
import TrackPage from "@/pages/TrackPage";
import BookPage from "@/pages/BookPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import ContactPage from "@/pages/ContactPage";
import LabelPage from "@/pages/LabelPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import { ChatWidget } from "@/components/ChatWidget";

const Protected = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

const AuthShell = ({ children }) => (
  <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">{children}</div>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/track" element={<TrackPage />} />
              <Route path="/track/:trackingNumber" element={<TrackPage />} />
              <Route path="/book" element={<Protected><BookPage /></Protected>} />
              <Route path="/dashboard" element={<Protected><DashboardPage /></Protected>} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/label/:id" element={<LabelPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/sign-in/*" element={<AuthShell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthShell>} />
              <Route path="/sign-up/*" element={<AuthShell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthShell>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <ChatWidget />
        <Toaster richColors position="top-center" />
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
